import { InjectionToken } from '@angular/core';
import { FilterPropertyType } from '../models/filter-property-type.type';

export interface FilterType {
  name: FilterPropertyType;
  component: any;
}

export const FILTER_TYPE = new InjectionToken<FilterType>('ADM_FILTER_TYPES');
